<template>
  <div class="page">
    <div style="display:none" v-title>检测报告</div>
    <template v-if="!noRights">
      <div class="register-favor" :style="avatar"></div>
      <div class="report-main">
        <div class="clearfix mb-20">
          <div class="fl option-w1 ellipsis">
            <span class="option-key">科室</span>
            <span class="option-value">{{detail.section || '未知'}}</span>
          </div>
          <div class="fl ellipsis">
            <span class="option-key option-key-long">主治医生</span>
            <span class="option-value">{{detail.doctor || '未知'}}</span>
          </div>
        </div>
        <div class="clearfix mb-20">
          <div class="fl option-w1 ellipsis">
            <span class="option-key">姓名</span>
            <span class="option-value">{{detail.name || '未知'}}</span>
          </div>
          <div class="fl option-w2 ellipsis">
            <span class="option-key">性别</span>
            <span class="option-value">{{detail.sex || '未知'}}</span>
          </div>
          <div class="fl ellipsis">
            <span class="option-key">年龄</span>
            <span class="option-value">{{detail.age || '未知'}}</span>
          </div>
        </div>
        <div class="clearfix mb-20">
          <div class="fl option-w1 ellipsis">
            <span class="option-key">血型</span>
            <span class="option-value">{{detail.blood || '未知'}}</span>
          </div>
          <div class="fl ellipsis option-w2">
            <span class="option-key">婚姻</span>
            <span class="option-value">{{marriage}}</span>
          </div>
          <div class="fl ellipsis">
            <span class="option-key">吸烟</span>
            <span class="option-value">{{smoking}}</span>
          </div>
        </div>
        <div class="flex space-between mb-20">
          <div class="ellipsis">
            <span class="option-key">饮酒</span>
            <span class="option-value">{{wine}}</span>
          </div>
          <div class="ellipsis">
            <span class="option-key option-key-long1">饮食习惯</span>
            <span class="option-value">{{taste}}</span>
          </div>
          <div class="ellipsis">
            <span class="option-key option-key-long1">熬夜习惯</span>
            <span class="option-value">{{sleep}}</span>
          </div>
        </div>
        <div class="mb-20 ">
          <span class="option-key">手机</span>
          <span class="option-value">{{detail.phone || '未知'}}</span>
        </div>
        <div class="mb-20">
          <span class="option-key">过敏史</span>
          <span class="option-value">
            <template v-if="detail.allergylist && detail.allergylist.length > 0" v-for="item in detail.allergylist">{{item.name}} - {{item.content}}, </template>
            <template v-if="detail.allergylist && detail.allergylist.length === 0">无</template>
          </span>
        </div>
        <div class="mb-20">
          <span class="option-key">家族史</span>
          <span class="option-value">
            <template v-if="detail.familylist && detail.familylist.length > 0" v-for="item in detail.familylist">{{item.name}} - {{item.content}}, </template>
            <template v-if="detail.familylist && detail.familylist.length === 0">无</template>
          </span>
        </div>
        <div class="mb-20">
          <span class="option-key option-too-long">建议复诊时间</span>
          <span class="option-value">{{detail.visitdate}}</span>
        </div>
        <div class="fixed-case">
          <h2>综合解决方案：</h2>
          <p>
            {{detail.conclusion}}
          </p>
        </div>
        <div class="flex flex-center report-table-head">
          <div class="flex-1">序号</div>
          <div class="flex-1">部位</div>
          <div class="flex-1">采样</div>
          <div class="flex-1">更多</div>
        </div>
        <div class="report-table-body">
          <div class="flex flex-center report-table-item" :key="key" v-for="(item, key) in detail.datalist" @click="toReportDetail(item.dataid)">
            <div class="flex-1">{{item.dataid}}</div>
            <div class="flex-1">{{item.parts || '未知'}}</div>
            <div class="flex-1">
              <span class="report-table-img" :style="item.checkimageStyle"></span>
            </div>
            <div class="flex-1">
              <i class="wsp-icon icon-arrow"></i>
            </div>
          </div>
        </div>
        <div class="report-time">
          <span class="option-key option-key-long mb-10">检测时间</span>
          <span class="option-value mb-10">{{detail.checkdate || '未知'}}</span>
        </div>
        <div>
          <span class="option-key option-key-long mb-10">医院地址</span>
          <span class="option-value mb-10">{{detail.companyaddress || '未知'}}</span>
        </div>
        <div>
          <span class="option-key option-key-long mb-10">联系电话</span>
          <span class="option-value mb-10">{{detail.companyphone || '未知'}}</span>
        </div>
        <div class="flex flex-center report-reword">
          <span class="report-reword-text">请对本次服务进行评价：</span>
          <div class="flex-1">
            <el-rate v-model="stars" @change="changeStar" :disabled="rateShow" :colors="['#08b3c3', '#08b3c3', '#08b3c3']"></el-rate>
          </div>
        </div>
        <div class="reback-case">
          <h2>反馈：</h2>
          <textarea v-model="feedBackText" :readonly="!showBtn"></textarea>
        </div>
        <div class="forget-btn" v-show="showBtn" @click="toFeedBack">提交</div>
      </div>
    </template>
    <template v-if="noRights">
      <div class="no-rights">参数错误！</div>
    </template>
  </div>
</template>

<script>
import { Toast } from 'mint-ui'
import { mapGetters } from 'vuex'
import { validateEmpty } from '../utils/validator'
import md5 from 'js-md5'
export default {
  name: 'Report',
  data () {
    return {
      stars: null,
      detail: {},
      feedBackText: '',
      showBtn: true,
      rateShow: false,
      noRights: false
    }
  },
  computed: {
    ...mapGetters({
      user: 'user'
    }),
    avatar: function () {
      return this.detail.avatar ? 'background-image:url("' + this.detail.avatar + '")' : ''
    },
    smoking: function () {
      if (this.detail.smoking === 3) {
        return '经常'
      } else if (this.detail.smoking === 2) {
        return '少吸'
      } else {
        return '不抽'
      }
    },
    marriage: function () {
      if (this.detail.marriage === 1) {
        return '未婚'
      } else if (this.detail.marriage === 2) {
        return '已婚'
      } else {
        return '保密'
      }
    },
    wine: function () {
      if (this.detail.wine === 3) {
        return '经常'
      } else if (this.detail.wine === 2) {
        return '少喝'
      } else {
        return '不喝'
      }
    },
    taste: function () {
      if (this.detail.taste === 3) {
        return '偏咸'
      } else if (this.detail.taste === 2) {
        return '适中'
      } else if (this.detail.taste === 4) {
        return '偏辣'
      } else if (this.detail.taste === 5) {
        return '爆辣'
      } else {
        return '清淡'
      }
    },
    sleep: function () {
      if (this.detail.sleep === 3) {
        return '经常'
      } else if (this.detail.sleep === 2) {
        return '偶尔'
      } else {
        return '从不'
      }
    }
  },
  created () {
    let checkid = this.$route.query.checkid
    let userid = this.$route.query.userid
    let params = {
      checkid: checkid,
      userid: userid
    }
    // 报告信息
    this.$axios.get('/Index/Doctor/CheckInfo', { params: params }).then((response) => {
      if (response.data.code !== 1000) {
        this.noRights = true
      } else {
        this.detail = response.data.data[0]
        this.stars = parseInt(this.detail.evaluate)
        this.rateShow = this.stars > 0
        this.detail.sex = this.detail.sex === 1 ? '男' : '女'
        if (this.detail.feedback) {
          this.showBtn = false
        } else {
          this.showBtn = true
        }
        this.feedBackText = this.detail.feedback
        this.detail.datalist.map((item) => {
          item.checkimageStyle = item.checkimage ? 'background-image: url("' + item.checkimage + '")' : ''
          return item
        })
      }
    }).catch(function () {})
  },
  methods: {
    // 反馈
    toFeedBack () {
      if (!this.stars) {
        Toast({
          message: '请选择您的评分 ~',
          duration: 1500
        })
        return
      }
      if (validateEmpty(this.feedBackText)) {
        Toast({
          message: '请输入您的宝贵反馈 ~',
          duration: 1500
        })
        return
      }
      let secret = 'tL92QZVP5WS1b7X8'
      let appkey = 'b9916545aR3c35E71fYFedq3b8i6ea9f'
      let formet = 'json'
      let serial = Date.parse(new Date()) / 1000
      let ver = '1.0'

      let sign = md5(secret + appkey + this.$route.query.checkid + this.stars + this.feedBackText + formet + serial + ver)
      let params = {
        serial: serial,
        ver: ver,
        formet: formet,
        secret: secret,
        appkey: appkey,
        sign: sign,
        feedback: this.feedBackText,
        evaluate: this.stars,
        checkid: this.$route.query.checkid
      }
      // 反馈
      this.$axios.get('/Index/Doctor/CheckFeedBack', { params: params }).then((response) => {
        if (response.data.code === 1000) {
          this.rateShow = true
          Toast({
            message: '感谢您的宝贵反馈！',
            duration: 1500
          })
          setTimeout(() => {
            this.showBtn = false
          }, 1000)
        }
      }).catch(function () {})
    },
    // 改变星星
    changeStar (val) {
      this.stars = val
    },
    // 检测报告详情
    toReportDetail (dataid) {
      this.$router.push({
        path: '/Report/MedicalInfo',
        query: {
          checkid: this.$route.query.checkid,
          dataid: dataid
        }
      })
    }
  }
}
</script>
<style lang="stylus" scoped>
.page
  position relative
  margin 0 auto
  width 720px
.register-favor
  position absolute
  top 30px
  left 50%
  transform translateX(-50%)
  margin 0 auto
  width 232px
  height 232px
  background-size 232px auto
  background-position center center
  font-size: 24px; /*px*/
  z-index 2
  background-image url('../assets/images/no-user.png')
  background-repeat no-repeat
  background-position center center
.report-main
  position absolute
  top 195px
  width 702px
  margin 0 9px 38px 9px
  padding 96px 30px 19px 30px
  background-color #fafafa
  border-radius 20px
  box-shadow 0 0 5px rgba(207,207,207,.7)
  z-index 1
.option-key
  position relative
  display inline-block
  font-size: 25px; /*px*/
  color #333333
  width 80px
  text-align justify
  line-height 0
  text-align-last justify
  vertical-align middle
  &:after
    position absolute
    right -20px
    top 0
    content '：'
    font-size: 25px; /*px*/
    color #333333
.option-key-long
  width 110px
.option-too-long
  width 160px
.option-value
  display inline-block
  max-width 520px
  vertical-align middle
  line-height 120%
  font-size: 25px; /*px*/
  color #666666
  padding-left 15px
  word-wrap break-word
.forget-btn
  margin 0 auto
  width 100%
  height 86px
  line-height 86px
  text-align center
  font-size: 35px; /*px*/
  letter-spacing 7px
  color #ffffff
  background-color #c4c4c4
  border-radius 5px
  background-image url('../assets/images/l-btn.png')
  background-size 100% 86px
  background-repeat no-repeat
  font-weight 300
.fixed-case
  border: 1px solid #b8bec2; /*no*/
  border-radius 5px
  h2
    margin-left 16px
    margin-top 16px
    font-size: 25px; /*px*/
    color #333333
  p
    padding 10px 20px
    line-height 150%
    background-color #fafafa
    text-indent 2em
    color #666
    word-wrap break-word
.reback-case
  margin-bottom 20px
  border: 1px solid #b8bec2; /*no*/
  border-radius 5px
  h2
    margin-left 16px
    margin-top 16px
    font-size: 25px; /*px*/
    color #333333
  textarea
    padding 10px 20px
    line-height 150%
    background-color #fafafa
    text-indent 2em
    color #666
    width 100%
    border none
    height 100px
.report-table-head
  margin-top 12px
  height 79px
  text-align center
  font-size: 25px; /*px*/
  color #333333
  border-bottom: 1px solid #c9c9c9; /*no*/
.report-table-body
  border-bottom: 1px solid #c9c9c9; /*no*/
  padding-bottom 20px
  text-align center
.report-table-item
  margin-top 32px
.report-table-img
  display inline-block
  width 87px
  height 65px
  background-image url('../assets/images/no-img.png')
  background-repeat no-repeat
  background-size 100% auto
  background-position center center
  background-color #e8e8e8
.icon-arrow
  display inline-block
  width 16px
  height 28px
  background-image url('../assets/images/icon-arrow.png')
.mb-10
  margin-bottom 10px
.mb-20
  margin-bottom 20px
.report-time
  margin-top 17px
.report-reword
  margin-top 36px
  margin-bottom 12px
.report-reword-text
  font-size: 25px; /*px*/
  color #333333
  margin-right 10px
.option-w1
  width 286px
.option-w2
  width 180px
.option-key-long1
  width 100px
</style>



// WEBPACK FOOTER //
// src/pages/Report.vue